// Single Collapsible Box
function Collapsible(el, options) {
  this.el = el;
  if (options && options.onToggleClick) this.onToggleClick = options.onToggleClick;

  this.init();
}

Collapsible.prototype.init = function() {
  this.toggleBtn = this.el.querySelector('.js-toggle');
  this.collapseWrapper = this.el.querySelector('.js-collapse-wrapper');
  this.content = this.collapseWrapper.querySelector('.js-content');

  this.collapsed = !this.toggleBtn.classList.contains('active');
  this.update = this.update.bind(this);
  this.update();

  var Frutiger700 = new window.FontFaceObserver('Frutiger', {
    weight: 700
  });
  var Frutiger400 = new window.FontFaceObserver('Frutiger', {
    weight: 400
  });

  this.requestUpdate = this.requestUpdate.bind(this);
  window.addEventListener('resize', this.requestUpdate);
  Promise.all([Frutiger400.load(), Frutiger700.load()]).then(this.requestUpdate);

  this.toggleBtn.addEventListener('click', (function() { this.onToggleClick(this) }).bind(this));
}

Collapsible.prototype.requestUpdate = function() {
  if (!this.raf) requestAnimationFrame(this.update);
}

Collapsible.prototype.onToggleClick = function() {
  this.toggleCollapsed();
}

Collapsible.prototype.toggleCollapsed = function(collapsed) {
  if (typeof collapsed !== 'undefined') {
    this.collapsed = collapsed;
  } else {
    this.collapsed = !this.collapsed;
  }
  this.update();
}

Collapsible.prototype.update = function() {
  if (!this.collapsed) {
    this.collapseWrapper.style.maxHeight = this.content.clientHeight + 'px';
    this.toggleBtn.classList.add('active');
    this.el.classList.add('active');
    this.toggleBtn.setAttribute('aria-expanded', true);
  } else {
    this.collapseWrapper.style.maxHeight = '';
    this.toggleBtn.classList.remove('active');
    this.el.classList.remove('active');
    this.toggleBtn.setAttribute('aria-expanded', false);
  }

  this.raf = false;
}

// Accordion handling closing and opening of sibling Collapsibles
function Accordion(el, options) {
  this.el = el;
  if (options && options.onChange) this.onChange = options.onChange;
  this.allCollapsible = options && options.hasOwnProperty('allCollapsible')  ? options.allCollapsible : false;
  this.initiallyOpen = options && options.hasOwnProperty('initiallyOpen')  ? options.initiallyOpen : false;
  this.onlyOneOpen = options && options.hasOwnProperty('onlyOneOpen')  ? options.onlyOneOpen : false;
  this.init();
}

Accordion.prototype.init = function() {
  var onToggleClick = Accordion.prototype.onToggleClick.bind(this);
  this.collapsibles = [].map.call(this.el.querySelectorAll('.js-collapsible'), function (el) {
    return new Collapsible(el, {
      onToggleClick: onToggleClick,
    });
  });

  if (this.collapsibles.length === 0) return;

  this.currentIndex = this.collapsibles.indexOf(
    this.collapsibles.find(function (el) {
      return !el.collapsed
    })
  );
  if (this.initiallyOpen && this.currentIndex === -1) {
    this.onToggleClick(this.collapsibles[0]);
  }
}

Accordion.prototype.onToggleClick = function(collapsible) {
  if (!this.allCollapsible) {
    if (!collapsible.collapsed) return;
  
    this.collapsibles.forEach(function(coll) {
      if (coll === collapsible) {
        coll.toggleCollapsed(false); // uncollapse
      } else {
        if (this.onlyOneOpen && !coll.collapsed) coll.toggleCollapsed(true); // collapse
      }
    });
  
    this.currentIndex = this.collapsibles.indexOf(collapsible);
  
    if (this.onChange) this.onChange(this.currentIndex);
  } else {
    collapsible.toggleCollapsed(!collapsible.collapsed);

    if (this.onlyOneOpen) {
      this.collapsibles.forEach(function(coll) {
        if (coll === collapsible) return;
        if (!coll.collapsed) coll.toggleCollapsed(true); // collapse
      });
    }
  }
}

// Invoke the Accordions
Array.prototype.forEach.call(document.querySelectorAll('.js-accordion'), function(el) {
  new Accordion(el, {
    allCollapsible: el.dataset.allCollapsible == 'true',
    initiallyOpen: el.dataset.initiallyOpen == 'true',
    onlyOneOpen: el.dataset.onlyOneOpen == 'true',
  });
});